var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnimatedLoadingIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 50",
    enableBackground: "new 0 0 100 50",
    xmlSpace: "preserve",
    style: {
      width: 20
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 20,
    cy: 25,
    r: 12
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    dur: "1s",
    values: "10;35;10",
    repeatCount: "indefinite",
    begin: 0.1
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 50,
    cy: 25,
    r: 12
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    dur: "1s",
    values: "10;35;10",
    repeatCount: "indefinite",
    begin: 0.2
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 80,
    cy: 25,
    r: 12
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    dur: "1s",
    values: "10;35;10",
    repeatCount: "indefinite",
    begin: 0.3
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnimatedLoadingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "animated-loading-icon.e41d75018ce1362e21fe0842ab7a13f5.svg";